import { render } from "./PresentationField.vue?vue&type=template&id=4a640bad"
import script from "./PresentationField.vue?vue&type=script&lang=js"
export * from "./PresentationField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__